import React, { useEffect, useState, useCallback, useRef, memo } from "react";
import {
  Input,
  Button,
  Spinner,
} from "reactstrap";

import { screenState } from "../../../store/screen/slice";
import { useAppSelector } from "../../../store/hooks";

const Index = (props: any) => {
  const { username } = useAppSelector(state => screenState(state));
  const { config, boxRef, onUpdate, actionEnd } = props;
  const [time, setTime] = useState(0);
  const [startTime, setStartTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [laps, setLaps] = useState<number[]>([]);
  const [split, setSplit] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (config.data.Lap) {
      setSplit(false);
    } else if (config.data.Split) {
      setSplit(true);
    }
    
    if (Object.hasOwnProperty.call(config.data, "Time")) {
      setTime(config.data.Time);
    }
    if (Object.hasOwnProperty.call(config.data, "StartTime")) {
      setStartTime(config.data.StartTime);
    }
    if (Object.hasOwnProperty.call(config.data, "Start")) {
      setIsRunning(config.data.Start);
    }
    if (Object.hasOwnProperty.call(config.data, "Laps")) {
      if (config.data.Laps.length) {
        if (!isOpen) {
          setIsOpen(true);
          // const height = toNumber(boxRef.current.style.height) * 2;
          // boxRef.current.style.height = `${450}px`;
        }
      }
      setLaps(config.data.Laps);
    } else {
      // initialize after refreshing
      config.data.Time = 0;
      config.data.StartTime = 0;
      config.data.Start = false;
      config.data.Laps = [];
      setTime(0);
      setStartTime(0);
      setIsRunning(false);
      setLaps([]);
    }
  }, [config.data]);

  useEffect(() => {
    if (!username) {
      let intervalId: NodeJS.Timeout;

      if (isRunning) {
        intervalId = setTimeout(() => {
          const increase = Math.floor((Date.now() - startTime) / 10);
          const data = config.data;
          data.Time = increase;
          onUpdate({ id: config.id, data: {...data} });
          setTime(increase);
        }, 50);
      }
      return () => clearTimeout(intervalId);
    }
  }, [isRunning, time]);

  // const hours = (time) => { return Math.floor(time / 360000); }
  const minutes = (time: number) => { return Math.floor((time % 360000) / 6000); }
  const seconds = (time: number) => { return Math.floor((time % 6000) / 100); }
  const milliseconds = (time: number) => { return time % 100; }

  const startAndStop = () => {
    const data = config.data;
    const start = Date.now() - time * 10;
    data.Start = !isRunning;
    data.StartTime = start;
    onUpdate({ id: config.id, data: {...data} });
    setIsRunning(!isRunning);
    setStartTime(start);
  };

  const resetOrLap = () => {
    const data = config.data;
    if (isRunning) {
      const last = time - laps.reduce((p, c) => p + c, 0);
      data.Laps = [...laps, last];
      setLaps(arrLaps => [...arrLaps, last]);
      if (!isOpen) {
        setIsOpen(true);
        // const height = toNumber(boxRef.current.style.height) * 2;
        // boxRef.current.style.height = `${450}px`;
        onUpdate({ id: config.id, height: 450, baseHeight: 450, minHeight: 150 });
        actionEnd(true);
      }
    }
    else {
      data.Time = 0;
      data.StartTime = 0;
      data.Start = false;
      data.Laps = [];
      setTime(0);
      setStartTime(0);
      setIsRunning(false);
      setLaps([]);
    }
    onUpdate({ id: config.id, data: {...data} });
  };

  const toNumber = (str: string) => {
    return Number(str.split("px")[0]);
  };

  const LapsDiv = (prop: any) => (
    <div className="d-flex flex-column fw-medium">
      <React.Fragment>
        <div className="d-flex flex-column-reverse">
          {(laps || []).map((recordTime, index) => (
            <div className="lap-time d-flex flex-row justify-content-between py-1 px-3 fs-16" key={index + 1}>
              <span>Lap{index + 1}</span>
              <span>
                { minutes(!split ? recordTime : laps.slice(0, index + 1).reduce((p, c) => p + c, 0)).toString().padStart(2, "0") }:
                { seconds(!split ? recordTime : laps.slice(0, index + 1).reduce((p, c) => p + c, 0)).toString().padStart(2, "0") }.
                { milliseconds(!split ? recordTime : laps.slice(0, index + 1).reduce((p, c) => p + c, 0)).toString().padStart(2, "0") }
              </span>
            </div>
          ))}
          <div className="lap-time d-flex flex-row justify-content-between py-0.5 px-3 font-medium fs-16">
            <span className="me-5">Lap{laps.length + 1}</span>
            <span>
              { minutes(!split ? prop.current : time).toString().padStart(2, "0") }:
              { seconds(!split ? prop.current : time).toString().padStart(2, "0") }.
              { milliseconds(!split ? prop.current : time).toString().padStart(2, "0") }
            </span>
          </div>
        </div>
      </React.Fragment>
    </div>
  )

  return (
    <React.Fragment>
      <div className="componentCore " style={{ height: '100%', width: '100%', position: 'absolute' }}>
        <div className="core-color px-8 pt-8" style={{ height: "225px" }}>
          <div className="d-flex flex-row align-items-baseline fw-medium fs-120" style={{ lineHeight: "100px" }}>
            <span className="text-center" style={{ width: "71.5385px" }}>{ minutes(time).toString().padStart(2, "0").split("")[0] }</span>
            <span className="text-center" style={{ width: "71.5385px" }}>{ minutes(time).toString().padStart(2, "0").split("")[1] }</span>
              <span>:</span>
            <span className="text-center" style={{ width: "71.5385px" }}>{ seconds(time).toString().padStart(2, "0").split("")[0] }</span>
            <span className="text-center" style={{ width: "71.5385px" }}>{ seconds(time).toString().padStart(2, "0").split("")[1] }</span>
            <span className="fw-medium fs-60" style={{ lineHeight: "40px" }}>
              <span>.</span>
              <span>{ milliseconds(time).toString().padStart(2, "0") }</span>
            </span>
          </div>

          <div className="flex flex-row justify-center gap-3 stopwatch-button">
            <Button
              className="core-btn core-default-btn flex items-center justify-center rounded-circle events-none-inside cursor-pointer rounded-full"
              style={{ height: "52px", width: "52px" }}
              onClick={startAndStop}
            >
              {isRunning ? 
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.47 60.47" style={{ height: "58px"}}>
                  <path d="M30.24,0A30.24,30.24,0,1,0,60.47,30.24,30.27,30.27,0,0,0,30.24,0ZM38.7,38.7H21.77V21.77H38.7Z" fill="#ffc780"/>
                </svg> : 
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.47 60.47" style={{ height: "52px"}}>
                  <path d="M30.24,0A30.24,30.24,0,1,0,60.47,30.24,30.27,30.27,0,0,0,30.24,0Zm9.34,31.66L26.13,41.15a1.74,1.74,0,0,1-2.74-1.42v-19a1.71,1.71,0,0,1,.94-1.54,1.71,1.71,0,0,1,1.8.12l13.45,9.5a1.75,1.75,0,0,1,0,2.84Z" fill="#91e2ca"/>
                </svg>
              }
            </Button>
            <Button 
              className={`core-default-btn ${isRunning? "core-flag" : ""} rounded-circle d-flex justify-content-center align-items-center p-0 boxShadow-none`}
              style={{ height: "52px", width: "52px" }}
              onClick={resetOrLap}
            >
              { isRunning ? 
                <i className="mdi mdi-flag-variant-outline fs-30"></i> : 
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.07 59.07" style={{ height: "52px"}}>
                  <path d="M29.53,0A29.54,29.54,0,1,0,59.07,29.53,29.57,29.57,0,0,0,29.53,0Zm0,57.07A27.54,27.54,0,1,1,57.07,29.53,27.57,27.57,0,0,1,29.53,57.07Z" fill="#5d5b53"/>
                  <path d="M40.92,28.66a1,1,0,0,0-1,1,10.5,10.5,0,1,1-2-6.12L31.57,23a1,1,0,0,0-1.08.92A1,1,0,0,0,31.41,25l8.32.66h.08a1,1,0,0,0,1-.93l.67-8.31a1,1,0,1,0-2-.16L39,21.68a12.37,12.37,0,0,0-9.6-4.5A12.48,12.48,0,1,0,41.92,29.66,1,1,0,0,0,40.92,28.66Z" fill="#5d5b53"/>
                </svg>
              }
            </Button>
          </div>
        </div>

        {isOpen? (
          <div className="core-color px-8 pb-8" style={{ height: "225px" }}>
            <div className="lap-time-box h-100 overflow-y-auto overflow-x-hidden  border-2" style={{ borderColor: "#111827" }}>
              <LapsDiv current={time - laps.reduce((p, c) => p + c, 0)}/>
            </div>
          </div>
        ) : null}
      </div>
      {username? (
        <div className="absolute h-100 w-100 top-0 start-0" style={{ zIndex: 2 }}></div>
      ) : null}
    </React.Fragment>
  );
};

export default memo(Index);